import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-tax-data',
  templateUrl: './tax-data.component.html',
  styleUrls: ['./tax-data.component.scss']
})
export class TaxDataComponent implements OnInit {
  @Input() inputForm: FormGroup;
  @Input() error: boolean;
  @Input() disableConditions = false;

  constructor() {}

  ngOnInit(): void {
    const ustPflichtig = this.inputForm.get('ustPflichtig');
    if (ustPflichtig && ustPflichtig.value) {
      this.taxMandatoryChanged({ value: true }, true);
    } else if (ustPflichtig.value === false) {
      this.taxMandatoryChanged({ value: false }, true);
    }
  }

  taxMandatoryChanged(event: Pick<MatRadioChange, 'value'>, init?: boolean) {
    const ustNr = this.inputForm.get('ustNr');
    const taxNr = this.inputForm.get('taxNr');
    const customerTaxIdentificationNumber = this.inputForm.get('customerTaxIdentificationNumber');
    if (event.value) {
      if (!init) {
        ustNr.patchValue('');
        taxNr.patchValue('');
        customerTaxIdentificationNumber.patchValue('');
      }
      ustNr.enable();
      ustNr.markAsUntouched();
      taxNr.enable();
      taxNr.markAsUntouched();
      customerTaxIdentificationNumber.clearValidators();
      customerTaxIdentificationNumber.patchValue('');
      customerTaxIdentificationNumber.markAsUntouched();
    } else if (event.value === false) {
      ustNr.clearValidators();
      ustNr.patchValue('');
      ustNr.markAsUntouched();
      taxNr.patchValue('');
      taxNr.markAsUntouched();
      customerTaxIdentificationNumber.enable();
      customerTaxIdentificationNumber.setValidators(Validators.required);
      customerTaxIdentificationNumber.markAsUntouched();
    } else {
      ustNr.clearValidators(); // Todo: Es gibt keinen Validator, der entfernt werden müsste. Aber eigentlich sollte da einer sein (denke ich)
      ustNr.patchValue('');
      ustNr.markAsUntouched();
      taxNr.patchValue('');
      taxNr.markAsUntouched();
      customerTaxIdentificationNumber.clearValidators();
      customerTaxIdentificationNumber.patchValue('');
      customerTaxIdentificationNumber.markAsUntouched();
    }
  }

  checkIfMandatory() {
    return this.inputForm.get('ustPflichtig').value;
  }
}
